/**
 * post1 1b — 위성사진 출처 «링크형» 표기(서버 컴포넌트 · 상태 없음). 문구는 lib/attribution/vworld 단일 원천.
 *   「출처: 국토교통부 공간정보 오픈플랫폼(브이월드) https://www.vworld.kr」 — 주소 부분이 실제 링크다(공공누리 1유형 «링크 제공»).
 *   ⛔ 링크(<a>) 안에 넣지 않는다(카드처럼 통째로 링크인 자리는 평문 VWORLD_ATTRIBUTION 을 title·캡션으로 쓴다).
 *   글자 크기는 부모 클래스가 정한다 — 쓰는 자리는 전부 12px 이상(.ainote 12px · .kd-cmp__cap · .av3-ban__cap 13px).
 */
import React from 'react'; // vitest(클래식 JSX) 렌더 검증용
import { VWORLD_ATTRIBUTION_LABEL, VWORLD_URL } from '@/lib/attribution/vworld';

export default function VworldCredit({ className }: { className?: string }) {
  return (
    <span className={className} data-vworld-credit="">
      {VWORLD_ATTRIBUTION_LABEL}{' '}
      <a href={VWORLD_URL} target="_blank" rel="noopener noreferrer">{VWORLD_URL}</a>
    </span>
  );
}
